import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ContainerOutlinedSvg from "@ant-design/icons-svg/es/asn/ContainerOutlined";
import AntdIcon from "../components/AntdIcon";
var ContainerOutlined = function ContainerOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ContainerOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ContainerOutlined.displayName = 'ContainerOutlined';
}
export default /*#__PURE__*/React.forwardRef(ContainerOutlined);